import React from 'react'
import {   Field} from 'redux-form'

export class SVMCDInputEp extends React.Component{

    constructor(props){
        super(props)
        let me = this
        this.svDDChange = this.svDDChange.bind(me)

    }
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log('sv*****Sep2******country selected')
        console.log(e)
        console.log(e.target.value)
        let orgm = e.target.value
        let orgi = e.currentTarget.id 
       

        this.props.svCountryDstChange(orgm,orgi)

    }
    componentWillReceiveProps(next){
        console.log('props changed SVString')
    }
   
    render(){
        
       
          /*svj21 start*/
          console.log('***svj21****  SVICO countryTwoTypes')
          const {countryTwoTypes} = this.props
          console.log("*******svj2****ADoc countryTwoTypes** START")
          console.log(countryTwoTypes)

          console.log("*******svj21****ADevice** END")

            /*svj21 end*/
        let me = this
       let {member,index, placeholder ='Port Z'} = this.props
        
            

          return (
            
   

                <Field  
                onChange={me.svDDChange}
                style={{minWidth:"120px",maxWidth:"210px"}}
                component="select" 
                id={`${member}.mcicountryDst`}
                name={`${member}.mcicountryDst`}
                className="form-control" >
                                                
                                                <option value="">Select Country /A2 Code</option>
                                                    {
                                        
                                                
                                        countryTwoTypes.map(  (o, idx)=>(  <option value={o.a2} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
    
                     </Field>    
                                  
          
           )
    }
}